module.exports = __webpack_public_path__ + "img/video.102cf894.svg";